import { FILE_STATUS } from './constants';
var fileResponse = function fileResponse(acceptedFiles, rejectedFiles, status) {
  return {
    acceptedFiles: acceptedFiles,
    rejectedFiles: rejectedFiles,
    status: status
  };
};
var uploadFiles = function uploadFiles(apiRoot, fileData, onProgressUpdated) {
  var fileUploadQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    var formData = new FormData();
    fileData.forEach(function (_ref2) {
      var file = _ref2.file,
        tid = _ref2.tid;
      formData.append(tid, file);
    });
    var params = {
      url: "".concat(apiRoot, "/upload").concat(fileUploadQuery),
      data: formData,
      onUploadProgress: function onUploadProgress(progress) {
        return onProgressUpdated(parseInt(progress.loaded / progress.total * 100, 10));
      },
      method: 'post',
      timeout: 0
    };
    return dispatch(application.req(params)).then(function (response) {
      return fileResponse(response.files, response.invalidFiles, FILE_STATUS.STATUS_FILETYPE_FAILURE);
    }).catch(function () {
      return fileResponse([], fileData.map(function (_ref3) {
        var file = _ref3.file;
        return file;
      }), FILE_STATUS.STATUS_UPLOAD_FAILURE);
    });
  };
};
export default uploadFiles;